import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { CouponWithUserAndRate, FilterCouponType } from "libs/dto/src/coupon";
import qs from "qs";

const coupon = async (page: number, filter?: FilterCouponType | null, take: number = 5) => {
  if (filter) {
    const response = await axios.get<{ page: number; data: CouponWithUserAndRate[] }>(`/coupons`, {
      params: {
        page: page,
        take: take,
        ...filter,
      },
      paramsSerializer: (params) => qs.stringify(params),
    });
    return response.data;
  }
  const response = await axios.get<{ page: number; data: CouponWithUserAndRate[] }>(`/coupons`, {
    params: {
      page: page,
    },
  });
  return response.data;
};

export const useCoupons = (page: number, filter?: FilterCouponType | null, take: number = 5) => {
  const {
    data: coupons,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["coupons", page, filter, take],
    queryFn: () => coupon(page, filter, take),
  });

  return { coupons, loading, error };
};
